import { call, put, takeLatest } from "redux-saga/effects"

// action
import {
    GET_CONSULATION_DASHBOARD_LIST,
    getConsulationDashboardListFail,
    getConsulationDashboardListSuccess
} from '../action/getConsulationDashboardListAction'

// api 
import getConsulationDashboardListApi from '../api/getConsulationDashboardListApi'

export function* getConsulationDashboardListSaga(action) {
    try {
        const response = yield call(() => getConsulationDashboardListApi(action.params))
        if (response.data.status === 1) {
            yield put(getConsulationDashboardListSuccess(response, action))
        } else {
            yield put(getConsulationDashboardListFail(response, action))
        }
    }
    catch (e) {
        yield put(getConsulationDashboardListFail(e.response, action))
    }

}

export default function* mySaga() {
    yield takeLatest(GET_CONSULATION_DASHBOARD_LIST, getConsulationDashboardListSaga)
}